import { Button } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchButton({ text,onClick  }) {
  return (
    <Button
      variant="contained"
      startIcon={<SearchIcon style={{ fontSize: "1.5rem" }} />}
      onClick={onClick}
      style={{
        background: "#9D03850F",
        borderRadius: "8px",
        fontSize: "14px",
        fontFamily: "Inter",
        height: "39px",
        color: "#9D0385",
        fontWeight: 600,
      }}
      sx={{
        width: { xs: "100%", sm: "48%" },
      }}
    >
      {text}
    </Button>
  );
}
